import { attributeTreeNode, attributes, attributesRoot } from './Attributes'
import { relationTreeNode, relations, relationsRoot } from './Relations'
import { typeTreeNode, types, typesRoot } from './Types'
import { actionTreeNode, actions, actionsRoot, createAction } from './Actions'
import { macroTreeNode, macros, macrosRoot, createMacro } from './Macros'
import { viewTreeNode, views, viewsRoot, createView } from './Views'
import { taskTreeNode, tasks, tasksRoot, createTask } from './Tasks'
import * as Types from 'Types'
import { getIcon } from './shared'
import ACLService from 'Services/ACL_Service'

treeNodeBuilderMap = {
  [Types.ACTION]: actionTreeNode
  [Types.ACTIONS]: actions
  [Types.ATTRIBUTE]: attributeTreeNode
  [Types.ATTRIBUTES]: attributes
  [Types.CREATE_ACTION]: createAction
  [Types.CREATE_MACRO]: createMacro
  [Types.CREATE_TASK]: createTask
  [Types.CREATE_VIEW]: createView
  [Types.MACRO]: macroTreeNode
  [Types.MACROS]: macros
  [Types.RELATION]: relationTreeNode
  [Types.RELATIONS]: relations
  [Types.TASKS]: tasks
  [Types.TYPE]: typeTreeNode
  [Types.TYPES]: types
  [Types.VIEW]: viewTreeNode
  [Types.VIEWS]: views
}

export default (props) ->
  builder = treeNodeBuilderMap[props.type]
  builder(props)

export getRoots = (userMode) ->
  rawRootData = [
    typesRoot,
    relationsRoot,
    attributesRoot,
    viewsRoot,
    actionsRoot,
    macrosRoot,
    tasksRoot
  ]
  writeAccess = ACLService.hasWriteAccess()
  rawRootData.filter((root) ->
    if !root.userMode
      return true
    else if root.writeAccess
      return writeAccess
    else
      return userMode >= root.userMode
  )

typesMap = {
  all_actions: Types.ACTIONS
  all_attributes: Types.ATTRIBUTES
  all_macros: Types.MACROS
  all_queries: Types.QUERIES
  all_relations: Types.RELATIONS
  all_tasks: Types.TASKS
  all_types: Types.TYPES
}
